import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StartAConsultation() {
  return <section data-section-id="222998" id="get-started-calltoaction" className="bg-secondary text-secondary-foreground py-24 md:py-32 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-secondary text-secondary-foreground rounded-2xl py-16 px-6 md:py-24 md:px-12 flex flex-col items-center text-center gap-8 shadow-none relative overflow-hidden">
          {/* Subtle watermark effect achieved via background styling or hidden img if needed, but following rules to keep structure */}
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight max-w-2xl text-background">
            What is the true ROI of your team's wellbeing?
          </h2>
          <div className="flex flex-col items-center gap-6">
            <Button asChild size="lg" variant="default" className="mt-2 text-base px-8 h-12 shadow-md hover:shadow-lg transition-shadow bg-primary text-primary-foreground font-default font-semibold">
              <Link to="/FeelGoodWorksServicesPage">
                Book a Consultation
              </Link>
            </Button>
            <Link to="/FeelGoodWorksServicesPage" className="text-accent-foreground hover:underline font-default text-lg transition-colors">
              View Wellbeing Risk Radar
            </Link>
          </div>
        </div>
      </div>
    </section>;
}